{
  "title": "Report an emergency",
  "callFirstTitle": "Call 911",
  "callFirstBody": "Calling is the fastest way to get help. This form is a second channel that sends your details to the LGU dispatchers.",
  "formTitle": "Send a report",
  "formLead": "Takes about 30 seconds. Only what is happening, where, and how to reach you are needed.",
  "whatHappening": "What is happening?",
  "chooseType": "Choose what is happening",
  "type_fire": "Fire",
  "type_flood": "Flood",
  "type_landslide": "Landslide",
  "type_medical": "Medical",
  "type_road_accident": "Road accident",
  "type_trapped_persons": "Trapped persons",
  "type_crime": "Crime",
  "type_other": "Other",
  "where": "Where is it?",
  "mapLabel": "Map of emergency reports",
  "barangayRequired": "Choose the barangay (needed because your location is not shared)",
  "landmarkHint": "A nearby landmark helps responders find the place.",
  "landmarkPlaceholder": "e.g. beside the chapel, near the school gate",
  "peopleAffected": "How many people are affected?",
  "injured": "Is anyone injured?",
  "description": "What should responders know?",
  "descriptionHint": "Optional. Keep it short.",
  "you": "Your contact details",
  "yourName": "Your name",
  "yourMobile": "Mobile number",
  "mobileHint": "Responders may call you back.",
  "noAccountNeeded": "No account needed. Signed-in residents get their details filled in.",
  "send": "Send report",
  "sending": "Sending…",
  "queuedTitle": "Saved — will send when online",
  "queuedBody": "Your report is saved on this phone and will be sent automatically as soon as there is signal. If you can, call 911 now.",
  "pendingTitle": "Waiting to send ({count})",
  "pendingItem": "{title} · saved {time}",
  "failedSend": "Could not be sent: {message}",
  "discard": "Discard",
  "sendAnother": "Send another report",
  "tryAgainNow": "Try sending now",
  "checkForm": "Please check the highlighted fields.",
  "trackTitle": "Report {ref}",
  "trackLead": "This page updates as dispatchers respond. Keep the link to check again later.",
  "status_received": "Received",
  "status_acknowledged": "Acknowledged",
  "status_dispatched": "Responders dispatched",
  "status_on_scene": "On scene",
  "status_resolved": "Resolved",
  "status_closed": "Closed",
  "closedNote": "This report is closed. If you still need help, call 911 or send a new report.",
  "respondersAssigned": "Responders have been assigned.",
  "reportedAt": "Reported {time}",
  "offlineSnapshot": "You are offline. This is the last saved status.",
  "timeline": "Updates",
  "author_reporter": "You",
  "author_staff": "Dispatcher",
  "author_system": "System",
  "addInfo": "Add information",
  "addInfoHint": "Tell responders anything new, for example if the situation changed.",
  "addInfoSend": "Send update",
  "addInfoSent": "Update sent",
  "notFound": "We couldn't open this report. Use the link shown after you sent it, on the same phone.",
  "copyLink": "Copy link to this report",
  "noUpdatesYet": "No updates yet. Dispatchers have your report.",
  "myTitle": "My emergency reports",
  "myEmpty": "No emergency reports from you or this device.",
  "waitingToSend": "Waiting to send",
  "dispatchTitle": "Dispatch",
  "unackCount": "{count} not acknowledged",
  "enableSound": "Enable alert sound",
  "soundOn": "Alert sound on",
  "smsNotConfigured": "SMS is NOT configured. Responders will not get text messages — new reports and assignments are only logged. Call the teams directly, and ask the administrator to set SEMAPHORE_API_KEY.",
  "smsNoTeams": "No responder team is set to get every new report by SMS. The administrator can turn this on under Responder teams.",
  "viewActive": "Active",
  "viewClosed": "Closed",
  "viewAll": "All",
  "search": "Search reports",
  "searchPlaceholder": "Ref, name, mobile or landmark",
  "queueEmpty": "No active reports. New reports appear here instantly.",
  "notAcknowledged": "Not acknowledged",
  "escalated": "Waiting over 2 minutes",
  "selectReport": "Select a report to see its details.",
  "reported": "Reported",
  "queuedOnDevice": "Saved on the reporter's phone at {time} (sent later)",
  "reporter": "Reporter",
  "callReporter": "Call {mobile}",
  "hasAccount": "Signed-in resident",
  "location": "Location",
  "noLocation": "No GPS location shared",
  "openInMaps": "Open in Google Maps",
  "accuracy": "±{m} m",
  "people": "People affected",
  "injuries": "Injuries",
  "priorFlagged": "{count} earlier report(s) from this number were flagged as prank or spam.",
  "photos": "Photos",
  "timelineAll": "Timeline",
  "internal": "Internal",
  "seenByReporter": "Seen by reporter",
  "actions": "Actions",
  "acknowledge": "Acknowledge",
  "priority": "Priority",
  "priority_low": "Low",
  "priority_normal": "Normal",
  "priority_high": "High",
  "priority_critical": "Critical",
  "setPriority": "Set priority",
  "assignTeam": "Assign responders",
  "team": "Team",
  "chooseTeam": "Choose a team",
  "noTeamsYet": "No responder teams yet. The administrator adds them under Responder teams.",
  "noteForTeam": "Note for the team (sent by SMS)",
  "assign": "Assign and send SMS",
  "assignedTo": "Assigned to {team}",
  "notAssigned": "Not assigned",
  "smsSent": "SMS sent to {count} responder(s)",
  "smsNotSent": "SMS is not configured — call the team.",
  "updateStatus": "Update status",
  "newStatus": "New status",
  "note": "Note",
  "showToReporter": "Show this note to the reporter",
  "saveUpdate": "Save update",
  "internalNote": "Internal note",
  "addNote": "Add note",
  "markDuplicate": "Mark as duplicate",
  "duplicateOf": "Reference of the original report",
  "duplicateBtn": "Mark duplicate and close",
  "duplicateOfLabel": "Duplicate of {ref}",
  "flagReport": "Flag report",
  "flag_prank": "Prank",
  "flag_spam": "Spam",
  "notFlagged": "Not flagged",
  "flagNote": "Reason",
  "saveFlag": "Save flag",
  "flaggedAs": "Flagged: {flag}",
  "disasterEvent": "Disaster event",
  "acknowledgedBy": "Acknowledged by {name}",
  "showList": "Back to the queue",
  "saved": "Saved",
  "newReportToast": "New emergency report {ref}",
  "waitingFor": "waiting {time}",
  "respondersTitle": "Responder teams",
  "respondersLead": "Teams and phone numbers that receive dispatch SMS. Dispatchers assign these teams to reports.",
  "newTeam": "New team",
  "editTeam": "Edit team",
  "teamName": "Team name",
  "teamDescription": "Description",
  "notifyOnNew": "Text this team about every new report",
  "active": "Active",
  "inactive": "Inactive",
  "contacts": "Contacts",
  "addContact": "Add contact",
  "contactName": "Name",
  "contactMobile": "Mobile number",
  "contactActive": "Gets SMS",
  "saveTeam": "Save team",
  "deleteTeam": "Delete team",
  "deleteConfirm": "Delete this team? Teams already assigned to reports cannot be deleted; turn them off instead.",
  "noTeams": "No responder teams yet. Add the teams that respond to emergencies so dispatchers can assign them.",
  "getsNew": "Gets every new report",
  "contactCount": "{count} contact(s)",
  "liveUpdates": "Live updates",
  "gpsOnly": "GPS pin shared",
  "responderTitle": "Responder · {type}",
  "responderLead": "You were assigned to this report. Share your location so the dispatcher and the person who reported can see you coming.",
  "responderPrivacy": "Your location is shared only for this report, only while sharing is on, and only with the dispatchers and the person who reported.",
  "startSharing": "Start sharing my location",
  "stopSharing": "Stop sharing",
  "sharingOn": "Sharing your location · last sent {ago} ago",
  "sharingStarting": "Finding your location…",
  "sharingOff": "Location sharing is off.",
  "keepOpen": "Keep this page open while you travel.",
  "arrived": "We have arrived",
  "arrivedDone": "Marked as on scene. Thank you.",
  "reportEnded": "This report is resolved or closed. Location sharing has stopped.",
  "linkInvalid": "This responder link is not valid any more. Ask the dispatcher for a new one.",
  "locationDenied": "Location is blocked for this site. Allow location in your browser settings, then try again.",
  "locationUnavailable": "Your location could not be found. Move to an open area and try again.",
  "directions": "Directions",
  "incident": "Incident",
  "responderMapLabel": "Map of the incident and the responder team",
  "onTheWay": "Help is on the way",
  "teamAway": "{team} is {distance} away (straight line) · updated {ago} ago",
  "responderLabel": "Responder",
  "responderAway": "{distance} away (straight line) · updated {ago} ago",
  "responderWaiting": "Waiting for the team to share its location.",
  "responderStale": "Last shared {ago} ago",
  "copyResponderLink": "Copy responder link",
  "responderLinkHint": "Sent to the team by SMS. Copy it if a responder needs it again.",
  "responderMarker": "Responder team",
  "callSending": "Sending your location…",
  "callNotice": "Calling from here also sends your location to the LGU dispatchers as a help request, so they can find you even if the call drops.",
  "callTitle": "Call to {name}",
  "callRequest": "Help request from a call",
  "calledVia": "Called {name} from the app",
  "calledViaShort": "Called {name}",
  "noMobileGiven": "No number given (caller not signed in)",
  "hqTitleTown": "Headquarters",
  "hqTitleBarangay": "{name} headquarters",
  "hqLive": "Live",
  "hqActive": "Active reports",
  "hqUnack": "Not acknowledged",
  "hqOnTheWay": "Teams on the way",
  "hqOnScene": "On scene",
  "hqResolvedToday": "Resolved today, of {total} filed",
  "hqCallsToday": "Calls from the app today",
  "hqEvacuees": "Evacuees · {open} sites open · room for {capacity}",
  "hqFeed": "Live reports",
  "hqNoReports": "No active reports. All clear.",
  "hqSites": "Evacuation sites",
  "hqNoSites": "No evacuation sites in this area yet.",
  "hqTeams": "Responder teams",
  "hqTeamFree": "Available",
  "hqTeamOn": "On {ref}",
  "hqFullscreen": "Full screen",
  "hqExitFullscreen": "Exit full screen",
  "hqReadOnly": "View only. The MDRRMO handles dispatch; reports here are in your barangay.",
  "hqMapLabel": "Map of active reports, responder teams and evacuation sites",
  "hqEmergencyOn": "Emergency mode is on"
}
